import React from 'react';
import {icon} from '@salesforce/retail-react-app/app/components/icons';
import {Icon} from '@salesforce/retail-react-app/app/components/shared/ui';
import {useHeaderContext} from '@amblique/king-living/app/contexts/header-context';

// Import SVG assets to register them in the sprite sheet
import '@amblique/king-living/app/assets/svg/arrow-right.svg';
import '@amblique/king-living/app/assets/svg/hotspot-content-arrow.svg';
import '@amblique/king-living/app/assets/svg/social-facebook.svg';
import '@amblique/king-living/app/assets/svg/social-instagram.svg';
import '@amblique/king-living/app/assets/svg/social-wechat.svg';
import '@amblique/king-living/app/assets/svg/social-youtube.svg';
import '@amblique/king-living/app/assets/svg/social-linkedin.svg';
import '@amblique/king-living/app/assets/svg/location-pin.svg';
import '@amblique/king-living/app/assets/svg/check.svg';
import '@amblique/king-living/app/assets/svg/shop.svg';
import '@amblique/king-living/app/assets/svg/plus.svg';
import '@amblique/king-living/app/assets/svg/minus.svg';
import '@amblique/king-living/app/assets/svg/cube.svg';
import '@amblique/king-living/app/assets/svg/shipping-box.svg';
import '@amblique/king-living/app/assets/svg/warranty.svg';
import '@amblique/king-living/app/assets/svg/home.svg';
import '@amblique/king-living/app/assets/svg/light-bulb.svg';
import '@amblique/king-living/app/assets/svg/plus-circle.svg';
import '@amblique/king-living/app/assets/svg/carousel-arrow-prev.svg';
import '@amblique/king-living/app/assets/svg/carousel-arrow-next.svg';
import '@amblique/king-living/app/assets/svg/gallery-arrow-left.svg';
import '@amblique/king-living/app/assets/svg/gallery-arrow-right.svg';
import '@amblique/king-living/app/assets/svg/gallery-pause.svg';
import '@amblique/king-living/app/assets/svg/gallery-play.svg';
import '@amblique/king-living/app/assets/svg/icon-cool.svg';
import '@amblique/king-living/app/assets/svg/icon-warm.svg';
import '@amblique/king-living/app/assets/svg/icon-air.svg';
import '@amblique/king-living/app/assets/svg/icon-cover.svg';
import '@amblique/king-living/app/assets/svg/icon-showrooms-online.svg';
import '@amblique/king-living/app/assets/svg/icon-online-exclusive.svg';
import '@amblique/king-living/app/assets/svg/size-circle.svg';
import '@amblique/king-living/app/assets/svg/instagram.svg';
import '@amblique/king-living/app/assets/svg/bookmark.svg';
import '@amblique/king-living/app/assets/svg/product-support-bookmark.svg';
import '@amblique/king-living/app/assets/svg/tune.svg';
import '@amblique/king-living/app/assets/svg/arrow-down.svg';
import '@amblique/king-living/app/assets/svg/close-filter.svg';
import '@amblique/king-living/app/assets/svg/magnifying-search.svg';
import '@amblique/king-living/app/assets/svg/check-circle.svg';
import '@amblique/king-living/app/assets/svg/close-modal.svg';
import '@amblique/king-living/app/assets/svg/search-icon.svg';
import '@amblique/king-living/app/assets/svg/union.svg';
import '@amblique/king-living/app/assets/svg/checkbox-tick.svg';
import '@amblique/king-living/app/assets/svg/alert-error.svg';
import '@amblique/king-living/app/assets/svg/alert-warning.svg';
import '@amblique/king-living/app/assets/svg/checkout-alert-warning.svg';
import '@amblique/king-living/app/assets/svg/alert-info.svg';
import '@amblique/king-living/app/assets/svg/alert-success.svg';
import '@amblique/king-living/app/assets/svg/upload.svg';
import '@amblique/king-living/app/assets/svg/download.svg';
import '@amblique/king-living/app/assets/svg/range-download.svg';
import '@amblique/king-living/app/assets/svg/cart.svg';
import '@amblique/king-living/app/assets/svg/shop-the-look-add-bag.svg';
import '@amblique/king-living/app/assets/svg/shop-the-look-hotspot-content-add.svg';
import '@amblique/king-living/app/assets/svg/shop-the-look-hotspot-content-sub.svg';
import '@amblique/king-living/app/assets/svg/shop-the-look-flyout-close.svg';
import '@amblique/king-living/app/assets/svg/search.svg';
import '@amblique/king-living/app/assets/svg/location.svg';
import '@amblique/king-living/app/assets/svg/profile.svg';
import '@amblique/king-living/app/assets/svg/global.svg';
import '@amblique/king-living/app/assets/svg/global-mega-menu.svg';
import '@amblique/king-living/app/assets/svg/close.svg';
import '@amblique/king-living/app/assets/svg/sandwich.svg';
import '@amblique/king-living/app/assets/svg/burger.svg';
import '../../assets/svg/header-map-pin.svg';
import '../../assets/svg/header-handbag.svg';
import '../../assets/svg/header-account.svg';
import '../../assets/svg/header-close.svg';
import '@amblique/king-living/app/assets/svg/icons-flag.svg';
import '@amblique/king-living/app/assets/svg/store-tile-showroom-pin.svg';
import '@amblique/king-living/app/assets/svg/icon-location.svg';
import '@amblique/king-living/app/assets/svg/icon-location-detail.svg';
import '@amblique/king-living/app/assets/svg/icon-phone.svg';
import '@amblique/king-living/app/assets/svg/icon-email.svg';
// Relative path: guarantees webpack resolves the sprite import even if the overlay index lags after adding a new asset.
import '../../assets/svg/order-confirmation-next-steps-email.svg';
import '../../assets/svg/order-confirmation-next-steps-payment.svg';
import '../../assets/svg/order-confirmation-next-steps-delivery.svg';
import '@amblique/king-living/app/assets/svg/quote.svg';
import '@amblique/king-living/app/assets/svg/icon-chevron-right-2.svg';
// Relative path: guarantees webpack resolves the sprite import even if the overlay index lags after adding a new asset.
import '../../assets/svg/icon-chevron-right-customize.svg';
import '@amblique/king-living/app/assets/svg/region-modal-other-regions-arrow.svg';
import '@amblique/king-living/app/assets/svg/region-picker-row-arrow.svg';
import '@amblique/king-living/app/assets/svg/arrow-bottom-right.svg';
import '@amblique/king-living/app/assets/svg/external-link.svg';
import '@amblique/king-living/app/assets/svg/road-sign-parking.svg';
import '@amblique/king-living/app/assets/svg/disability-wheelchair.svg';
import '@amblique/king-living/app/assets/svg/remove-circle.svg';
import '@amblique/king-living/app/assets/svg/drag-to-rotate.svg';
import '@amblique/king-living/app/assets/svg/ar.svg';
import '@amblique/king-living/app/assets/svg/cylindo-zoom.svg';
import '@amblique/king-living/app/assets/svg/cylindo-zoom-out.svg';
import '@amblique/king-living/app/assets/svg/fullscreen.svg';
import '@amblique/king-living/app/assets/svg/select-chevron-icon.svg';
import '@amblique/king-living/app/assets/svg/left-arrow.svg';
import '@amblique/king-living/app/assets/svg/checkout-continue-back.svg';
import '@amblique/king-living/app/assets/svg/promo-coupon-tag.svg';
import '@amblique/king-living/app/assets/svg/promo-coupon-close.svg';
import '@amblique/king-living/app/assets/svg/toggle-chevron-up.svg';
import '@amblique/king-living/app/assets/svg/toggle-chevron-down.svg';
import '@amblique/king-living/app/assets/svg/add-to-cart-strip-chevron.svg';
import '@amblique/king-living/app/assets/svg/logout.svg';
import '@amblique/king-living/app/assets/svg/profile-circle.svg';
import '@amblique/king-living/app/assets/svg/lock.svg';
import '@amblique/king-living/app/assets/svg/icon-tag.svg';
import '@amblique/king-living/app/assets/svg/checkout-card-lock.svg';
import '@amblique/king-living/app/assets/svg/checkout-trust-lock.svg';
import '@amblique/king-living/app/assets/svg/visibility.svg';
import '@amblique/king-living/app/assets/svg/visibility-off.svg';

// Base icon component (without header context)
const BrandLogoIcon = icon('brand-logo', {viewBox: '0 0 112 24'});

/**
 * BrandLogo Component
 *
 * Automatically switches color based on header state:
 * - Light header style → Dark logo (black/grayAlpha.100)
 * - Dark header style (gradient) → Light logo (white)
 *
 * @param {Object} props - Component props
 * @param {string} [props.variant='auto'] - 'auto' | 'dark' | 'light'
 */
export const BrandLogo = ({variant = 'auto', ...props}) => {
  // Try to get header context (may not be available in all contexts)
  let headerStyle = 'light';

  try {
    const context = useHeaderContext();

    headerStyle = context?.headerStyle || 'light';
  } catch {
    // Header context not available, use default light style
  }

  // Determine logo color based on variant or header style
  const getLogoColor = () => {
    if (variant === 'dark') return 'grayAlpha.100';
    if (variant === 'light') return 'text.white';

    // Auto mode - derive from header style
    return headerStyle === 'dark' ? 'text.white' : 'grayAlpha.100';
  };

  return <BrandLogoIcon color={getLogoColor()} {...props} />;
};
export const ArrowRightIcon = icon('arrow-right', {viewBox: '0 0 18 16'});
export const HotspotContentArrowIcon = icon('hotspot-content-arrow');
export const SocialFacebookIcon = icon('social-facebook');
export const SocialInstagramIcon = icon('social-instagram');
export const SocialWechatIcon = icon('social-wechat');
export const SocialYoutubeIcon = icon('social-youtube');
export const SocialLinkedinIcon = icon('social-linkedin');
export const LocationPinIcon = icon('location-pin');
export const CheckIcon = icon('check');
export const ShopIcon = icon('shop');
export const PlusIcon = icon('plus');
export const MinusIcon = icon('minus');
/** Promotion accordion minus — inline path so `color` applies (sprite minus keeps #8C683B). */
export const PromotionAccordionMinusIcon = (props) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M15.2002 7.40002C15.5316 7.40002 15.8002 7.66865 15.8002 8.00002C15.8002 8.3314 15.5316 8.60002 15.2002 8.60002H0.800195C0.468824 8.60002 0.200195 8.3314 0.200195 8.00002C0.200195 7.66865 0.468824 7.40002 0.800195 7.40002H15.2002Z"
      fill="currentColor"
    />
  </Icon>
);
export const CubeIcon = icon('cube');
export const ShippingBoxIcon = icon('shipping-box');
export const WarrantyIcon = icon('warranty');
export const HomeIcon = icon('home');
export const LightBulbIcon = icon('light-bulb');
export const PlusCircleIcon = icon('plus-circle');
export const CarouselArrowPrevIcon = icon('carousel-arrow-prev');
export const CarouselArrowNextIcon = icon('carousel-arrow-next');
export const GalleryArrowLeftIcon = icon('gallery-arrow-left');
export const GalleryArrowRightIcon = icon('gallery-arrow-right');
export const GalleryPauseIcon = icon('gallery-pause');
export const GalleryPlayIcon = icon('gallery-play');
export const IconCool = icon('icon-cool');
export const IconWarm = icon('icon-warm');
export const IconAir = icon('icon-air');
export const IconCover = icon('icon-cover');
export const IconShowroomsOnline = icon('icon-showrooms-online');
export const IconOnlineExclusive = icon('icon-online-exclusive');
export const SizeCircle = icon('size-circle');
export const InstagramIcon = icon('instagram');
export const BookmarkIcon = icon('bookmark');
export const ProductSupportBookmarkIcon = icon('product-support-bookmark', {viewBox: '0 0 12 12'});
export const TuneIcon = icon('tune');
export const ArrowDownIcon = icon('arrow-down');
export const CloseFilterIcon = icon('close-filter');
export const MagnifyingSearchIcon = icon('magnifying-search');
export const CheckCircleIcon = icon('check-circle');
export const CloseModalIcon = icon('close-modal');
/** Search drawer submit — 32×32, stroke 1.5 (Figma ArrowRight, not scaled 18×16). */
export const SearchDrawerSubmitIcon = (props) => (
  <Icon viewBox="0 0 32 32" fill="none" color="currentColor" {...props}>
    <path
      d="M5 16H27"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M18 7L27 16L18 25"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </Icon>
);
export const SearchIcon = icon('search-icon', {viewBox: '0 0 20 20'});
/** Search submit arrow. */
export const SubmitSearchIcon = (props) => (
  <Icon viewBox="0 0 33.4736 31.3421" color="currentColor" {...props}>
    <path
      fill="currentColor"
      d="M17.2725 0.219622C17.5653 -0.0732392 18.0401 -0.0731756 18.333 0.219622L33.249 15.1356C33.2541 15.1406 33.2587 15.1461 33.2637 15.1513C33.3123 15.2018 33.3501 15.2583 33.3818 15.3173C33.3936 15.3392 33.4064 15.3605 33.416 15.3837C33.4235 15.4018 33.4276 15.4209 33.4336 15.4393C33.4574 15.5126 33.4736 15.5896 33.4736 15.6708C33.4736 15.7538 33.4566 15.8325 33.4316 15.9071C33.4262 15.9236 33.4227 15.9408 33.416 15.9569C33.4063 15.9805 33.3929 16.0021 33.3809 16.0243C33.3494 16.0826 33.3117 16.1384 33.2637 16.1884C33.2586 16.1937 33.2543 16.1998 33.249 16.205L18.333 31.1229C18.0401 31.415 17.5651 31.4153 17.2725 31.1229C16.9798 30.8302 16.9801 30.3543 17.2725 30.0614L30.9131 16.4208H0.75C0.336144 16.4205 0.000107804 16.0847 0 15.6708C0 15.2568 0.336078 14.9211 0.75 14.9208H30.9131L17.2725 1.28017C16.9798 0.987448 16.9801 0.512527 17.2725 0.219622Z"
    />
  </Icon>
);
export const UnionIcon = icon('union');
export const CheckboxTickIcon = icon('checkbox-tick', {viewBox: '0 0 16 12'});
export const AlertErrorIcon = icon('alert-error');
export const AlertWarningIcon = icon('alert-warning');
export const CheckoutAlertWarningIcon = icon('checkout-alert-warning');
export const AlertInfoIcon = icon('alert-info');
export const AlertSuccessIcon = icon('alert-success');
export const UploadIcon = icon('upload');
export const DownloadIcon = icon('download');
export const RangeDownloadIcon = icon('range-download', {viewBox: '0 0 18 18'});
export const CartIcon = icon('cart');

/** Shop the Look add-to-bag (20px viewBox, stroke uses currentColor). */
export const ShopTheLookAddBagIcon = icon('shop-the-look-add-bag');

/** Shop the Look content hotspot — closed (plus), fixed palette from design SVG. */
export const ShopTheLookHotspotContentAddIcon = icon('shop-the-look-hotspot-content-add', {
  viewBox: '0 0 80 80',
});

/** Shop the Look content hotspot — open (minus bar), fixed palette from design SVG. */
export const ShopTheLookHotspotContentSubIcon = icon('shop-the-look-hotspot-content-sub', {
  viewBox: '0 0 80 80',
});

/** Shop the Look drawer close — 20px strokes, uses currentColor */
export const ShopTheLookFlyoutCloseIcon = icon('shop-the-look-flyout-close');
export const SearchSimpleIcon = icon('search', {viewBox: '0 0 20 20'});
export const LocationSimpleIcon = icon('location');
export const ProfileIcon = icon('profile');
export const GlobalIcon = icon('global');
/** Filled globe for mobile mega menu footer only; header uses {@link GlobalIcon} */
export const GlobalMegaMenuIcon = icon('global-mega-menu');
export const CloseIcon = icon('close', {viewBox: '0 0 20 20'});
/** Checkout applied promo pill — product tag (Figma 3339:9850 / 3339:13307) */
export const PromoCouponTagIcon = icon('promo-coupon-tag', {viewBox: '0 0 17 17'});
/** Checkout applied promo pill — remove (Figma 3339:9850 / 3339:13307) */
export const PromoCouponCloseIcon = icon('promo-coupon-close', {viewBox: '0 0 17 17'});
export const SandwichIcon = icon('sandwich');
export const BurgerIcon = icon('burger', {viewBox: '0 0 24 24'});
/** Header showroom pin — 16×16. */
export const HeaderMapPinIcon = icon('header-map-pin', {viewBox: '0 0 16 16'});
/** Header bag icon — 22×22. */
export const HeaderHandbagIcon = icon('header-handbag', {viewBox: '0 0 22 22'});
/** Header account icon — 20×20. */
export const HeaderAccountIcon = icon('header-account', {viewBox: '0 0 20 20'});
/** Header close icon — 20×20. */
export const HeaderCloseIcon = icon('header-close', {viewBox: '0 0 20 20'});
export const FlagIcon = icon('icons-flag');
export const StoreTileShowroomPinIcon = icon('store-tile-showroom-pin', {viewBox: '0 0 12 13'});
export const MyLocationIcon = icon('icon-location');
export const LocationDetailIcon = icon('icon-location-detail');
export const PhoneIcon = icon('icon-phone');
export const EmailIcon = icon('icon-email');
/** Figma checkout confirmation — Next steps email (3342:24039) */
export const OrderConfirmationNextStepsEmailIcon = icon('order-confirmation-next-steps-email', {
  viewBox: '0 0 24 24',
});
/** Figma checkout confirmation — Next steps payment (3342:24040) */
export const OrderConfirmationNextStepsPaymentIcon = icon('order-confirmation-next-steps-payment', {
  viewBox: '0 0 24 24',
});
/** Figma checkout confirmation — Next steps delivery (3342:24041) */
export const OrderConfirmationNextStepsDeliveryIcon = icon('order-confirmation-next-steps-delivery', {
  viewBox: '0 0 24 24',
});
export const QuoteIcon = icon('quote');
export const ChevronRightIcon2 = icon('icon-chevron-right-2', {viewBox: '0 0 7 13'});
export const ChevronRightCustomizeIcon = icon('icon-chevron-right-customize', {viewBox: '0 0 12 13'});

/** Figma: region modal “Other countries/ regions” link arrow (15×13) */
export const RegionModalOtherRegionsArrowIcon = icon('region-modal-other-regions-arrow', {viewBox: '0 0 15 13'});

/** Figma: region picker row arrow (20×19, fill) */
export const RegionPickerRowArrowIcon = icon('region-picker-row-arrow');
export const ArrowBottomRightIcon = icon('arrow-bottom-right');
/** Figma ACCHIST external link (node 5759:51646 — expand-6, 12px) */
export const ExternalLinkIcon = icon('external-link', {viewBox: '0 0 12.15 12.15'});
export const ParkingIcon = icon('road-sign-parking');
export const WheelchairIcon = icon('disability-wheelchair');
export const RemoveCircleIcon = icon('remove-circle');
export const DragToRotateIcon = icon('drag-to-rotate');
export const ArIcon = icon('ar');
export const CylindoZoomIcon = icon('cylindo-zoom');
export const CylindoZoomOutIcon = icon('cylindo-zoom-out');
export const FullscreenIcon = icon('fullscreen');
export const SelectChevronIcon = icon('select-chevron-icon');
export const LeftArrowIcon = icon('left-arrow', {viewBox: '0 0 8 13'});
export const CheckoutContinueBackIcon = icon('checkout-continue-back', {viewBox: '0 0 20 20'});
export const ToggleChevronUpIcon = icon('toggle-chevron-up');
export const ToggleChevronDownIcon = icon('toggle-chevron-down');
export const AddToCartStripChevronIcon = icon('add-to-cart-strip-chevron', {viewBox: '0 0 13 12'});
export const LogoutIcon = icon('logout');
export const ProfileCircleIcon = icon('profile-circle');
export const LockIcon = icon('lock', {viewBox: '0 0 16 20'});
export const TagIcon = icon('icon-tag');
export const CheckoutCardLockIcon = icon('checkout-card-lock', {viewBox: '0 0 20 20'});
export const CheckoutTrustLockIcon = icon('checkout-trust-lock', {viewBox: '0 0 18 25'});
export const CheckoutVisibilityIcon = icon('visibility', {viewBox: '0 0 22 14'});
export const CheckoutVisibilityOffIcon = icon('visibility-off', {viewBox: '0 0 22 14'});
export * from '@salesforce/retail-react-app/app/components/icons';
